import React, { useEffect, useState } from "react";
import contactImg from "../assest/images/contact-us/cloud.webp";
import img1 from "../assest/images/banner-img/1.jpg";
import { Link } from "react-router-dom";
import { apiRequest } from "../services/allApi";
import { errorAlert, successAlert } from "../services/sweetAlert";
import Loader from "../component/loader.jsx";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
function Premium_Package() {
  const BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;
  const [isLoading, setIsLoading] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  const [homeData, setHomeData] = useState([]);
  const Home = async () => {
    setIsLoading(true);
    try {
      const res = await apiRequest("home");
      setIsLoading(false);
      if (res?.success) {
        setHomeData(res.data);
      } else {
        errorAlert(res.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    Home();
  }, []);
  // Mobile panel state
  const [mobilePanelOpen, setMobilePanelOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("filter");

  const [open, setOpen] = useState({
    price: true,
    style: true,
    type: true,
    duration: false,
    time: false,
    language: false,
  });

  const [showMore, setShowMore] = useState(false);

  const toggle = (key) => {
    setOpen((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  // Recommended packages data
  const recommendedPackages = [
    {
      img: img1,
      title: "Leh-Ladakh Bike Expedition",
      location: "Leh, Nubra Valley",
      price: "₹2,898",
    },
    {
      img: img1,
      title: "Kashmir Great Lakes Trek",
      location: "Srinagar, Sonmarg",
      price: "₹3,500",
    },
    {
      img: img1,
      title: "Spiti Valley Adventure",
      location: "Manali, Kaza",
      price: "₹4,200",
    },
    {
      img: img1,
      title: "Golden Triangle Tour",
      location: "Delhi, Agra, Jaipur",
      price: "₹2,500",
    },
  ];

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div>
      <Helmet>
        <title>Premium Ladakh Tour Packages | Ladakh MotoDrive</title>

        <meta
          name="description"
          content="Enjoy premium Ladakh tour packages with luxury stays, private vehicles & curated experiences. Travel Leh in comfort with Ladakh MotoDrive."
        />

        <meta
          name="keywords"
          content="premium ladakh tour packages, luxury ladakh trip, leh luxury tour package, ladakh deluxe package, ladakh honeymoon luxury tour, ladakh private tour, ladakh motodrive premium tours"
        />

        <link
          rel="canonical"
          href="https://ladakhmotodrive.com/premium-ladakh-tour-packages"
        />
        {/* Open Graph */}
        <meta
          property="og:title"
          content="Premium Ladakh Tour Packages | Ladakh MotoDrive"
        />
        <meta
          property="og:description"
          content="premium ladakh tour packages, luxury ladakh trip, leh luxury tour package, ladakh deluxe package, ladakh honeymoon luxury tour, ladakh private tour, ladakh motodrive premium tours"
        />
        <meta
          property="og:url"
          content="https://ladakhmotodrive.com/premium-ladakh-tour-packages"
        />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Premium Ladakh Tour Packages | Ladakh MotoDrive"
        />
        <meta
          name="twitter:description"
          content="premium ladakh tour packages, luxury ladakh trip, leh luxury tour package, ladakh deluxe package, ladakh honeymoon luxury tour, ladakh private tour, ladakh motodrive premium tours"
        />
      </Helmet>

      {/* <h1>Premium Ladakh Tour Packages</h1> */}
      {/* ===== Banner ===== */}
      <div className="container-fulid">
        <div className="cloud-img">
          <div className="cloud-move">
            <img src={contactImg} alt="cloud" />
          </div>
        </div>
        <div className="page-banner page-banner1">
          <div className="main-title">
            <h3 className="breadcrumb-title">Premium Ladakh Tour Packages</h3>
            <ul className="breadcrumb-menu">
              <li>
                <a className="text-white" href="index.html">
                  Home
                </a>
              </li>
              <li>-</li>
              <li className="active">Ladakh Car Trip</li>
            </ul>
          </div>
        </div>
      </div>

      {/* ===== CONTENT ===== */}
      <section className="bg-light pt-5 pb-5">
        <div class="search-wrapper">
          <input
            type="text"
            placeholder="Search in Ladakh Bike Expedition | Leh Based Company ..."
            class="search-input"
          />

          <button class="search-btn">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-search"
            >
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
          </button>
        </div>
        <div className="container">
          <div className="row">
            {/* ================= SIDEBAR ================= */}
            <div className="col-lg-4 desktop-sidebar">
              <div className="togo-tour-sidebar mb-30  ">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <h4 className="mb-0">Filter</h4>

                  <a href="javascript:void(0);">Clear</a>
                </div>

                {/* PRICE RANGE WIDGET */}
                <PriceRange />

                {/* TOUR STYLES */}
                <Widget
                  title="Tour styles"
                  open={open.style}
                  toggle={() => toggle("style")}
                  items={["Natural", "Cuisine", "Biking", "Family"]}
                />

                {/* TOUR TYPES */}
                <div className="togo-tour-widget">
                  <h4
                    className="togo-tour-widget-title"
                    onClick={() => toggle("type")}
                  >
                    Tour types <span className="icon">⌃</span>
                  </h4>

                  {open.type && (
                    <div className="inner_content">
                      <ul>
                        {[
                          "Group tour",
                          "Private tour",
                          "Daily tour",
                          "Package tour",
                        ].map((item, i) => (
                          <li key={i}>
                            <input type="checkbox" id={item} />
                            <label htmlFor={item}>{item}</label>
                          </li>
                        ))}

                        {!showMore && (
                          <li>
                            <button onClick={() => setShowMore(true)}>
                              Show more
                            </button>
                          </li>
                        )}

                        {showMore && (
                          <>
                            {[
                              "City Tours",
                              "Cultural Tours",
                              "Family Friendly Tours",
                            ].map((item, i) => (
                              <li key={i}>
                                <input type="checkbox" id={item} />
                                <label htmlFor={item}>{item}</label>
                              </li>
                            ))}

                            <li>
                              <button onClick={() => setShowMore(false)}>
                                Show less
                              </button>
                            </li>
                          </>
                        )}
                      </ul>
                    </div>
                  )}
                </div>

                {/* OTHER FILTERS */}
                <Widget
                  title="Duration"
                  open={open.duration}
                  toggle={() => toggle("duration")}
                  items={[
                    "0 - 3 hours",
                    "3 - 5 hours",
                    "5 - 8 hours",
                    "8 - 12 hours",
                  ]}
                />
              </div>
            </div>

            {/* RIGHT SIDE */}
            <div className="col-lg-8">
              <div className="filter-topbar">
                {/* LEFT SIDE */}
                <div className="filter-left">
                  <span className="tour-count">24 tours found</span>

                  <button className="clear-filter">Clear filter</button>
                </div>

                {/* RIGHT SIDE */}
                <div className="filter-right">
                  <select className="sort-dropdown">
                    <option>Popular</option>
                    <option>Price Low → High</option>
                    <option>Price High → Low</option>
                    <option>Newest</option>
                  </select>
                </div>
              </div>

              <section className="  ">
                <div className="container">
                  {/* Heading */}

                  {/* Cards */}
                  <div className="row g-4">
                    {homeData?.tours
                      ?.filter(
                        (item) => item.category_name === "Premium_Package",
                      )
                      .map((item, index) => (
                        <div className="col-lg-6 col-md-6" key={index}>
                          <div className="package-card">
                            <div className="package-card-img-wrap">
                              <Link
                                to={`/TourDetail/${item.slug}`}
                                className="card-img"
                              >
                                <img
                                  src={`${BASE_URL}${item?.image}`}
                                  alt={item.title}
                                />
                              </Link>

                              <div className="batch">
                                <span className="date">{item.duration}</span>

                                <div className="location">
                                  <ul className="location-list">
                                    <li>
                                      <Link to={`/TourDetail/${item.slug}`}>
                                        Ladakh
                                      </Link>
                                    </li>
                                    <li>
                                      <Link to={`/TourDetail/${item.slug}`}>
                                        {item.tour_type}
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>

                            <div className="package-card-content">
                              <div className="card-content-top">
                                <h5>
                                  <Link to={`/TourDetail/${item.slug}`}>
                                    {item.title}
                                  </Link>
                                </h5>

                                <div className="location-area">
                                  <ul className="location-list scrollTextAni">
                                    {item.location?.split("-").map((loc, i) => (
                                      <li key={i}>
                                        <Link to={`/TourDetail/${item.slug}`}>
                                          {loc.trim()}
                                        </Link>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              </div>

                              <div className="card-content-bottom">
                                <div className="price-area">
                                  <h6>Starting From:</h6>

                                  <span>
                                    ₹{item.price} <del>₹{item.mrp}</del>
                                  </span>

                                  <p>TAXES INCL/PERS</p>
                                </div>

                                <Link
                                  className="primary-btn2"
                                  to={`/TourDetail/${item.slug}`}
                                >
                                  Book a ride
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>

      {/* ================= MOBILE PANEL ================= */}
      {/* Mobile Toggle Button */}
      <div className="mobile-panel-toggle d-lg-none">
        <button
          className="mobile-filter-btn"
          onClick={() => setMobilePanelOpen(true)}
          aria-label="Open filters"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
          </svg>
          <span>Filter</span>
        </button>
      </div>

      {/* Mobile Panel Overlay */}
      <div
        className={`mobile-panel-overlay ${mobilePanelOpen ? "active" : ""}`}
        onClick={() => setMobilePanelOpen(false)}
      ></div>

      {/* Mobile Slide Panel */}
      <div className={`mobile-filter-panel ${mobilePanelOpen ? "open" : ""}`}>
        <div className="mobile-panel-header">
          <h3>Filter & Recommend</h3>
          <button
            className="mobile-panel-close"
            onClick={() => setMobilePanelOpen(false)}
            aria-label="Close panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        {/* Tab Navigation */}
        <div className="mobile-panel-tabs">
          <button
            className={`tab-btn ${activeTab === "filter" ? "active" : ""}`}
            onClick={() => setActiveTab("filter")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
            </svg>
            Filter
          </button>
          <button
            className={`tab-btn ${activeTab === "recommend" ? "active" : ""}`}
            onClick={() => setActiveTab("recommend")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
            </svg>
            Recommend
          </button>
        </div>

        {/* Tab Content */}
        <div className="mobile-panel-content">
          {/* Filter Tab Content */}
          {activeTab === "filter" && (
            <div className="filter-content">
              <div className="d-flex align-items-center justify-content-between mb-3">
                <h4 className="mb-0">Filter</h4>
                <a href="javascript:void(0);">Clear</a>
              </div>

              {/* Mobile Price Range */}
              <div className="mobile-price-widget togo-tour-widget">
                <h4 className="togo-tour-widget-title">
                  Price range <span>⌃</span>
                </h4>
                <div className="price-inputs">
                  <div>
                    <label>Min. price</label>
                    <input value="$0" readOnly />
                  </div>
                  <div>
                    <label>Max. price</label>
                    <input value="$2333" readOnly />
                  </div>
                </div>
              </div>

              {/* Mobile Tour Styles */}
              <Widget
                title="Tour styles"
                open={open.style}
                toggle={() => toggle("style")}
                items={["Natural", "Cuisine", "Biking", "Family"]}
              />

              {/* Mobile Tour Types */}
              <div className="togo-tour-widget">
                <h4
                  className="togo-tour-widget-title"
                  onClick={() => toggle("type")}
                >
                  Tour types <span className="icon">⌃</span>
                </h4>

                {open.type && (
                  <div className="inner_content">
                    <ul>
                      {[
                        "Group tour",
                        "Private tour",
                        "Daily tour",
                        "Package tour",
                      ].map((item, i) => (
                        <li key={i}>
                          <input type="checkbox" id={`mobile-${item}`} />
                          <label htmlFor={`mobile-${item}`}>{item}</label>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>

              {/* Mobile Duration */}
              <Widget
                title="Duration"
                open={open.duration}
                toggle={() => toggle("duration")}
                items={[
                  "0 - 3 hours",
                  "3 - 5 hours",
                  "5 - 8 hours",
                  "8 - 12 hours",
                ]}
              />

              <button className="apply-filter-btn">Apply Filters</button>
            </div>
          )}

          {/* Recommend Tab Content */}
          {activeTab === "recommend" && (
            <div className="recommend-content">
              <h4>Recommended For You</h4>
              <p className="recommend-subtitle">Based on your preferences</p>

              <div className="recommended-packages">
                {recommendedPackages.map((pkg, index) => (
                  <div className="recommended-package-card" key={index}>
                    <div className="recommended-img">
                      <img src={pkg.img} alt={pkg.title} />
                    </div>
                    <div className="recommended-info">
                      <h5>{pkg.title}</h5>
                      <p className="location">{pkg.location}</p>
                      <span className="price">{pkg.price}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      <section className="home-testimonial bg-light home-blog">
        <div className="container">
          <div className="row mt-4">
            <div className="col-lg-10 offset-lg-1">
              <div className="content-box text-center">
                {/* Short Content */}
                <p className="intro-text">
                  A journey through Ladakh on two wheels is one of the most
                  thrilling and unforgettable travel experiences in India. At
                  Ladakh MotoDrive, we offer expertly crafted Ladakh bike tour
                  packages that allow you to explore the region with complete
                  confidence, proper planning, and a true sense of adventure....
                </p>

                {/* FULL CONTENT */}
                {showMore && (
                  <div className="full-content text-start">
                    <p>
                      For travelers who seek comfort, exclusivity, and a truly
                      refined escape, Ladakh MotoDrive brings you thoughtfully
                      curated premium Ladakh tour packages designed to turn your
                      dream journey into a seamless reality. Imagine exploring
                      the breathtaking landscapes of Ladakh without worrying
                      about planning.
                    </p>

                    <p>
                      For travelers who seek comfort, exclusivity, and a truly
                      refined escape, Ladakh MotoDrive brings you thoughtfully
                      curated premium Ladakh tour packages designed to turn your
                      dream journey into a seamless reality. Imagine exploring
                      the breathtaking landscapes of Ladakh without worrying
                      about planning, logistics, or comfort. These packages are
                      crafted for those who want more than just a trip—they want
                      an experience defined by ease, privacy, and unforgettable
                      moments. Whether it’s a romantic getaway or a peaceful
                      retreat in the mountains, every journey is designed to
                      feel special
                    </p>

                    <h4>Features Of Premium Ladakh Tour Packages</h4>
                    <p>
                      Our premium packages are designed to offer a superior
                      travel experience with attention to every detail. These
                      tours focus on comfort, personalization, and high-quality
                      services throughout your journey. Key features of our
                      premium experience include:
                    </p>

                    <ul>
                      <li>
                       * Luxury hotels, boutique stays, and premium camps with
                        modern amenities.
                      </li>
                      <li>
                       * Private vehicles with experienced drivers for a
                        comfortable journey.
                      </li>
                      <li>
                       * Customized itineraries based on your travel preferences
                        .
                      </li>
                      <li>
                       * Priority bookings for accommodations and activities
                      </li>
                      <li>* Personalized assistance and on-ground support</li>
                    </ul>

                    <p>
                      Every element of the journey is carefully arranged so that
                      you can relax and enjoy Ladakh without worrying about
                      logistics or planning.
                    </p>

                    <h4>Premium Ladakh Tour Packages For Couples</h4>
                    <p>
                      Premium Ladakh tours are especially popular among couples
                      looking for a romantic and peaceful getaway. The serene
                      landscapes, quiet lakes, and beautiful mountain views
                      create the perfect setting for memorable experiences. Our
                      packages are designed to provide privacy, comfort, and
                      special touches that enhance your trip. Why couples prefer
                      premium packages.
                    </p>

                    <ul>
                      <li>* Private vehicles for uninterrupted travel.</li>
                      <li>* Peaceful and scenic accommodations.</li>
                      <li>* Flexible itineraries with relaxed pacing .</li>
                      <li>
                       * Opportunities for romantic experiences in unique
                        locations .
                      </li>
                    </ul>
                    <p>
                      The Ladakh trip cost for couples in premium packages
                      generally ranges from ₹60,000 to ₹1,50,000, depending on
                      the level of luxury, duration, and inclusions. These
                      packages are ideal for honeymoon trips, anniversaries, or
                      special occasions.
                    </p>

                    <h4>
                      Destinations Covered in Premium Ladakh Tour Packages
                    </h4>
                    <p>
                      Our premium tours cover all major destinations in Ladakh
                      while ensuring upgraded stays and enhanced experiences at
                      each location. Key destinations include:
                    </p>
                    <ul>
                      <li>
                        <b>Leh:</b> The starting point offering cultural
                        experiences, monasteries, and local markets, along with
                        comfortable luxury stays for acclimatization.
                      </li>
                      <li>
                        <b>Nubra Valley:</b> : Known for its scenic beauty and
                        sand dunes, with premium camps and boutique
                        accommodations for a unique stay experience.
                      </li>
                      <li>
                        <b>Pangong Lake:</b>: A major highlight featuring
                        crystal-clear waters and breathtaking surroundings, with
                        high-end camps offering comfort in remote locations.
                      </li>
                      <p>
                        In addition to these, premium tours may include visits
                        to monasteries, scenic viewpoints, and other attractions
                        that showcase Ladakh’s natural beauty and cultural
                        richness.
                      </p>
                    </ul>

                    <h4>Premium Ladakh Tour Packages Cost</h4>
                    <p>
                      While premium Ladakh tour packages come at a higher cost
                      compared to standard tours, they offer exceptional value
                      in terms of comfort, convenience, and overall experience.
                      What adds value to premium tours:
                    </p>
                    <ul>
                      <li>
                       * High-quality accommodations with better facilities
                      </li>
                      <li>
                       * Private transportation ensures flexibility and comfort
                      </li>
                      <li> * Time-saving arrangements with priority bookings</li>
                      <li>
                       * Personalized services tailored to your preferences
                      </li>
                      <p>
                        These packages are ideal for travelers who want to avoid
                        the challenges of budget travel and instead enjoy a
                        smooth, well-organized journey. The focus is on creating
                        a memorable experience rather than just covering
                        destinations.
                      </p>
                    </ul>

                    <h4>Best Time to Visit Ladakh </h4>
                    <p>
                      The best time to opt for a premium Ladakh tour is between
                      May and September, when the region is fully accessible and
                      travel conditions are at their best. During these months,
                      major routes from Manali and Srinagar remain open,
                      allowing smooth and comfortable journeys across Ladakh.
                      The weather is relatively stable, with clear skies and
                      pleasant daytime temperatures, making it ideal for
                      sightseeing and relaxation
                    </p>
                    <p>
                      This period also ensures that most luxury hotels, boutique
                      stays, and premium camps are fully operational, allowing
                      travelers to experience Ladakh with maximum comfort and
                      convenience. Scenic destinations like Pangong Lake and
                      Nubra Valley are easier to access, and the overall travel
                      experience becomes more enjoyable. While nights can still
                      be cold due to high altitude, proper planning ensures a
                      seamless and luxurious journey.
                    </p>

                    <h4>Why Choose Ladakh MotoDrive? </h4>
                    <p>
                      Choosing the right travel partner is essential for a
                      premium experience, and Ladakh MotoDrive ensures that
                      every detail of your journey is handled with care. Reasons
                      to choose us:
                    </p>
                    <ul>
                      <li>
                      *  Experienced local team with in-depth knowledge of Ladakh
                      </li>
                      <li>* Carefully curated premium packages</li>
                      <li>* Transparent pricing with no hidden costs</li>
                      <li>* Flexible and customizable itineraries</li>
                      <li>* Dedicated support throughout the trip</li>
                    </ul>

                    <p>
                      Plan your premium Ladakh journey with Ladakh MotoDrive and
                      enjoy a travel experience that combines luxury, comfort,
                      and adventure. Whether it is a honeymoon, a special
                      celebration, or a relaxing getaway, we are here to create
                      a personalized trip that you will remember for years to
                      come.
                    </p>
                    <h4>FAQs</h4>
                    <p>
                      <b>1. What is the cost of a premium Ladakh trip?</b>
                      The cost of a premium Ladakh trip usually starts from
                      around ₹60,000 per couple and can go higher depending on
                      the duration, accommodation type, and level of
                      customization.
                    </p>
                    <p>
                      <b>
                        2. Are premium packages suitable for honeymoon trips?
                      </b>
                      Yes, premium packages are ideal for honeymoon trips as
                      they offer privacy, luxury stays, and personalized
                      services, creating a perfect romantic experience in
                      Ladakh’s scenic environment.
                    </p>
                    <p>
                      <b>
                        3. What is included in premium Ladakh tour packages?
                      </b>
                      Premium packages typically include luxury accommodations,
                      private vehicles with drivers, customized itineraries,
                      permits, and personalized support to ensure a smooth and
                      comfortable travel experience.
                    </p>
                    <p>
                      <b>4. Can premium tours be customized?</b>
                      Yes, all premium Ladakh tours can be customized based on
                      your preferences, including duration, destinations,
                      accommodation type, and specific experiences you wish to
                      include. antic experience in Ladakh’s scenic environment.
                    </p>
                    <p>
                      <b>
                        5. What makes premium packages different from standard
                        tours?
                      </b>
                      Premium packages focus on comfort, privacy, and
                      personalized services, offering better accommodations,
                      private transport, and a more relaxed travel experience
                      compared to standard or budget tours.
                    </p>
                  </div>
                )}

                {/* Button */}
                <button
                  className="read-btn"
                  onClick={() => setShowMore(!showMore)}
                >
                  {showMore ? "Read Less ↑" : "Read More ↓"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Premium_Package;

/* ===============================
   REUSABLE WIDGET COMPONENT
================================*/

function Widget({ title, open, toggle, items }) {
  return (
    <div className="togo-tour-widget">
      <h4 className="togo-tour-widget-title" onClick={toggle}>
        {title} <span className="icon">⌃</span>
      </h4>

      {open && (
        <div className="inner_content">
          <ul>
            {items.map((item, i) => (
              <li key={i}>
                <input type="checkbox" id={item} />
                <label htmlFor={item}>{item}</label>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

/* ===============================
   PRICE RANGE COMPONENT
================================*/

function PriceRange() {
  const [min, setMin] = useState(0);
  const [max, setMax] = useState(2333);

  const MIN_GAP = 50;
  const MAX_VALUE = 5000;

  const handleMin = (e) => {
    const value = Math.min(Number(e.target.value), max - MIN_GAP);
    setMin(value);
  };

  const handleMax = (e) => {
    const value = Math.max(Number(e.target.value), min + MIN_GAP);
    setMax(value);
  };

  const progress = {
    left: `INR{(min / MAX_VALUE) * 100}%`,
    right: `INR{100 - (max / MAX_VALUE) * 100}%`,
  };

  return (
    <div className="price-widget togo-tour-widget">
      <h4 className="togo-tour-widget-title">
        Price range <span>⌃</span>
      </h4>

      {/* SLIDER */}
      <div className="range-slider">
        <div className="slider-track"></div>
        <div className="slider-progress" style={progress}></div>

        <input
          type="range"
          min="0"
          max={MAX_VALUE}
          value={min}
          onChange={handleMin}
          className="range-min"
        />

        <input
          type="range"
          min="0"
          max={MAX_VALUE}
          value={max}
          onChange={handleMax}
          className="range-max"
        />
      </div>

      {/* PRICE BOX */}
      <div className="price-inputs">
        <div>
          <label>Min. price</label>
          <input value={`$${min}`} readOnly />
        </div>

        <div>
          <label>Max. price</label>
          <input value={`$${max}`} readOnly />
        </div>
      </div>
    </div>
  );
}
